<template>
  <div class="sc-chart-widget__wrapper" v-loading="isLoading">
    <div class="sc-chart-widget">
      <div class="sc-chart-widget__controls-title">
        <r-text type="caption">
          {{ $t("period") }}
        </r-text>
      </div>
      <ul class="sc-chart-widget__controls">
        <li
          :class="[
            `sc-chart-widget__controls-item`,
            { active: dataStep === item }
          ]"
          v-for="item in controlsItem"
          :key="item"
          @click="changeDataStep(item)"
        >
          <r-text type="caption">
            {{ $t(item) }}
          </r-text>
        </li>
      </ul>
    </div>
    <sc-charts-builder
      v-if="chartData"
      :chart-data="chartData"
      :title="title"
      :type="chartType"
      :changeChartType="changeChartType"
      slot="second-footer"
    />
  </div>
</template>

<script>
import moment from "moment";
import scChartsBuilder from "../charts/charts";
import { prepareChartData, historyRequest } from "../charts/helpers";

const controlsItem = ["hour", "day", "week", "month"];
const chartTypes = ["type-1", "type-2", "type-3"];

export default {
  props: {
    type: {
      type: String,
      default: "widget"
    },
    url: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ""
    }
  },
  components: { scChartsBuilder },
  data() {
    return {
      isLoading: false,
      dataStep: "day",
      chartType: "type-1",
      chartData: null,
      chartTypes,
      controlsItem
    };
  },
  watch: {
    currentHistoryConfig() {
      this.getChartData();
    }
  },
  computed: {
    currentHistoryConfig() {
      const to = moment(new Date())
        .zone(0)
        .format();
      const from =
        this.dataStep === "hour"
          ? moment(new Date())
              .zone(0)
              .subtract(2, this.dataStep)
              .format()
          : moment(new Date())
              .zone(0)
              .subtract(1, this.dataStep)
              .format();
      let step;
      switch (this.dataStep) {
        case "hour":
          step = 15;
          break;
        case "day":
          step = 120;
          break;
        case "week":
          step = 540;
          break;
        case "month":
          step = 1600;
          break;
        default:
          break;
      }

      return { from, to, step };
    }
  },
  methods: {
    async getChartData() {
      this.isLoading = true;
      try {
        const data = await historyRequest(this, { url: this.url });
        this.chartData = prepareChartData(data, this.title);
        this.isLoading = false;
      } catch (e) {
        console.log(e);
        this.isLoading = false;
      }
    },
    changeChartType(e) {
      this.chartType = e;
    },
    changeDataStep(val) {
      if (val === this.dataStep) return;

      this.dataStep = val;
    }
  },
  created() {
    this.getChartData();
  }
};
</script>

<style lang="scss">
.sc-chart-widget__wrapper {
  overflow: hidden;
  .sc-chart-widget {
    min-width: 640px;
    height: auto;
    display: flex;
    &__controls {
      margin: 0;
    }
  }
  .sc-chart-builder__wrapper {
    height: 320px;
    .echarts {
      margin-top: 0;
      margin-left: 0;
    }
    .sc-chart-builder {
      &__controllers {
        top: -24px;
        left: auto;
        right: 0;
      }
    }
  }
}
</style>
